import React, { CSSProperties } from "react"

import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { FormattedBanner } from "./utils"
import useIsOnCompact from "~/hooks/useIsOnCompact"

import css from "./Banner.module.scss"

interface PropTypes {
  bannerToDisplay: FormattedBanner
}

export default function Banner(props: PropTypes) {
  const { bannerToDisplay } = props
  const isCompact = useIsOnCompact()
  if (!bannerToDisplay) return null
  return (
    <div
      className={css.root}
      style={{
        ...({
          "--banner-background-color": bannerToDisplay.backgroundColor,
        } as CSSProperties),
      }}
    >
      <a href={bannerToDisplay.linkTo.url}>
        <div className={css.bannerContainer}>
          <GatsbyImage
            image={bannerToDisplay.banner}
            alt={bannerToDisplay.bannerAlt}
            objectFit="cover"
            objectPosition={isCompact ? "center" : "right"}
            className={css.banner}
          />
        </div>
      </a>
    </div>
  )
}

export const query = graphql`
  fragment Banner on PrismicBanner {
    data {
      bannerList: banner_list {
        backgroundColor: background_color
        bannerAlt: banner_alt
        fromDate: from_date
        toDate: to_date
        linkTo: link_to {
          ...PrismicLink
        }
        desktopImage: desktop_image {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
        mobileImage: mobile_image {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
      defaultBannerLink: default_banner_link {
        ...PrismicLink
      }
      defaultDesktopBanner: default_desktop_banner {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
      }
      defaultMobileBanner: default_mobile_banner {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
      }
      defaultBannerAlt: default_banner_alt
      defaultBannerBackgroundColor: default_banner_background_color
    }
  }
`
